import React, {useState} from 'react';
import 'dayjs/locale/ru'
import {Button, Divider, Modal, notification} from "antd";
import CategoryCreateForm from "./CategoryCreateForm";
import {useCreateCategoryMutation} from "../../../store/api/CategoryApi";
import {CategoryCreateDTO} from "../../../types/category/CategoryCreateDTO";

const CategoryCreateButton = () => {
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [createCategory] = useCreateCategoryMutation()

    const onOpenHandler = () => setVisible(true)

    const onCloseHandler = () => setVisible(false)

    const onFinishHandler = async (dto: CategoryCreateDTO) => {
        setLoading(true)
        await createCategory(dto)
            .then(() => {
                notification.success({
                    message: 'Категория успешно создана!',
                    duration: 5
                })
            })
            .catch(error => notification.error({
                message: `Ошибка ${error.status}`,
                description: error.data.message,
                duration: 5
            }))
        setVisible(false)
        setLoading(false)
    }

    return (
        <>
            <Button type={'primary'} onClick={onOpenHandler}>
                + Добавить категорию
            </Button>
            <Modal
                title="Добавить категорию"
                open={visible}
                onCancel={onCloseHandler}
                okText="Создать"
                destroyOnClose
                okButtonProps={{
                    disabled: loading,
                    form: "category-create-form",
                    htmlType: "submit"
                }}
            >
                <Divider/>
                <CategoryCreateForm category={undefined} onFinish={onFinishHandler}/>
            </Modal>
        </>
    );
}

export default CategoryCreateButton;